import ModalForm from '../../shared/components/modal-form';

export default class DeleteAccountModal extends ModalForm {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$otherReasonRadioInput = this.$element.find('#deleteReasonOther');
    this.$otherReasonInput = this.$element.find(
      '.deleteAccountModal-otherReason'
    );

    this.bindEvents();
  }

  bindEvents() {
    this.$element.on(
      'change.deleteAccountModal-otherReasonRadio',
      this.handleDeleteOtherReasonChange.bind(this)
    );

    if (this.$element.hasClass('modal')) {
      super.bindEvents(...arguments);
    }
  }

  unbindEvents() {
    this.$element.off(
      'change.deleteAccountModal-otherReasonRadio',
      this.handleDeleteOtherReasonChange
    );

    if (this.$element.hasClass('modal')) {
      super.unbindEvents(...arguments);
    }
  }

  handleDeleteOtherReasonChange() {
    if (this.$otherReasonRadioInput.is(':checked')) {
      this.$otherReasonInput.show('fade');
    } else {
      this.$otherReasonInput.hide('fade');
    }
  }

  handleModalShow() {
    super.handleModalShow();

    this.resetForm();
  }

  resetForm() {
    $('input[name="delete_reason"]').prop('checked', false);
    $('.deleteAccountModal-otherReason').val('');
    this.$otherReasonInput.hide();
  }
}
